<div class="row">
    <div class="col-lg-12">       
        <div class="text-center mt-sm-5 mb-4 text-white-50">
            <div>
                <a routerLink="/" class="d-inline-block auth-logo">
                    <img src="assets/myfile/MyFile-Name-White.png" alt="myfile" height="100" />
                </a>
            </div>
            <p class="mt-3 fs-15 fw-medium" i18n = "@@Header_text_Message">Welcome to MyFile - Canada's most advanced and preferred Multi-industry document request, AI and analytics provider. With MyFile you can request documents from many different sectors including but not limited to Hospitals, Police Organizations and Insurance Companies. We have over 100+ legal documents you can request at any time using our Shopping Cart. Take your business to the next level with our cutting-edge document analysis software. Sign up to get started.</p>
        </div>
    </div>
</div>
